module.exports = __webpack_public_path__ + "img/building_physics.a2d5c19e.jpg";